import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

/**
 * This is to route to the office dashboard when we have office selected.
 */

@Injectable()
export class AppDashboardRouteGuard implements CanActivate {

  constructor(
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (JSON.parse(localStorage.getItem('ngStorage-selectedOffice')) &&
          JSON.parse(localStorage.getItem('ngStorage-selectedOffice'))['_id']
      ) {
        this.router.navigate([`/offices/${JSON.parse(localStorage.getItem('ngStorage-selectedOffice'))['_id']}/dashboard`]);
        } else {
        this.router.navigate([`/dashboard`]);
        }
      return false;
  }
}
